var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { CategoryLinkModalData, ShowCategoryLinkModalActions } from './show.category.link.modal.provider';
import { AlertifyService } from '../../../services/alertify.service';
var ShowCategoryLinkModalComponent = /** @class */ (function (_super) {
    __extends(ShowCategoryLinkModalComponent, _super);
    function ShowCategoryLinkModalComponent(dialogRef, actions, alertify, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.alertify = alertify;
        _this.link = data.link;
        _this.jsonApi = data.jsonApi;
        return _this;
    }
    ShowCategoryLinkModalComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    ShowCategoryLinkModalComponent.prototype.copyLink = function () {
        this.copyToClip(this.link);
    };
    ShowCategoryLinkModalComponent.prototype.copyJsonApi = function () {
        this.copyToClip(this.jsonApi);
    };
    ShowCategoryLinkModalComponent.prototype.copyToClip = function (content) {
        var aux = document.createElement('input');
        aux.setAttribute('value', content);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand('copy');
        document.body.removeChild(aux);
        this.alertify.success('Link is copied to the clipboard');
    };
    return ShowCategoryLinkModalComponent;
}(BaseComponent));
export { ShowCategoryLinkModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/show.category.link.modal/show.category.link.modal.component.ts.pre-build-optimizer.js